import { z } from 'zod';
import type { LoggingTimestampLabel, LoggingTimestampValue } from './helpers/enums.ts';

const LOGGING_TIMESTAMP_ITEMS_LABELS = [
  'Layout',
  'ANSIC',
  'Unix Date',
  'Ruby Date',
  'RFC822',
  'RFC822Z',
  'RFC850',
  'RFC1123',
  'RFC1123Z',
  'RFC3339',
  'RFC3339 Nano',
  'Kitchen',
  'Stamp',
  'Stamp Milli',
  'Stamp Micro',
  'Stamp Nano',
] as const satisfies readonly LoggingTimestampLabel[];

const LOGGING_TIMESTAMP_VALUES = [
  "01/02 03:04:05PM '06 -0700",
  'Mon Jan _2 15:04:05 2006',
  'Mon Jan _2 15:04:05 MST 2006',
  'Mon Jan 02 15:04:05 -0700 2006',
  '02 Jan 06 15:04 MST',
  '02 Jan 06 15:04 -0700',
  'Monday, 02-Jan-06 15:04:05 MST',
  'Mon, 02 Jan 2006 15:04:05 MST',
  'Mon, 02 Jan 2006 15:04:05 -0700',
  '2006-01-02T15:04:05Z07:00',
  '2006-01-02T15:04:05.999999999Z07:00',
  '3:04PM',
  'Jan _2 15:04:05',
  'Jan _2 15:04:05.000',
  'Jan _2 15:04:05.000000',
  'Jan _2 15:04:05.000000000',
] as const satisfies readonly LoggingTimestampValue[];

export const loggingTimestampFormatSchema = z.enum([...LOGGING_TIMESTAMP_ITEMS_LABELS, '']);

export const loggingTimestampFormatRequiredSchema = loggingTimestampFormatSchema.refine((val) => val !== '', {
  message: 'Choose a log timestamp format',
});

export const loggingTimestampFormatValuesSchema = z.enum(LOGGING_TIMESTAMP_VALUES);
